import { Flex } from "@mantine/core";
import { IconCaretDownFilled } from "@tabler/icons-react";
import moment from "moment";
import { useTranslation } from "react-i18next";

import { NumberFormatter, Text } from "components";

interface BankCreditRequestHeaderProps {
  creditAmount?: number;
  repaymentTerm?: Date;
  monthlyInstallment?: number;
  isExpanded: boolean;
  onToggle: () => void;
}

export const BankCreditRequestHeader = ({
  creditAmount,
  repaymentTerm,
  monthlyInstallment,
  isExpanded,
  onToggle,
}: BankCreditRequestHeaderProps) => {
  const { t } = useTranslation();

  const headerItems = [
    {
      label: t("bankCredit.header.info.creditAmount"),
      value: creditAmount,
      formatValue: () => (
        <NumberFormatter
          value={creditAmount}
          suffix={" CHF"}
          fixedDecimalScale={true}
          decimalScale={2}
        />
      ),
    },
    {
      label: t("bankCredit.header.info.repaymentTerm"),
      value: repaymentTerm,
      formatValue: () => (
        <Text size="md" fw={500}>
          {moment(repaymentTerm).format("DD.MM.YYYY")}
        </Text>
      ),
    },
    {
      label: t("bankCredit.header.info.monthlyInstallment"),
      value: monthlyInstallment,
      formatValue: () => (
        <NumberFormatter
          value={monthlyInstallment}
          suffix={" CHF"}
          fixedDecimalScale={true}
          decimalScale={2}
        />
      ),
    },
  ];

  return (
    <Flex
      direction="row"
      gap="md"
      mb={"md"}
      align="center"
      bg={"var(--mantine-color-gray-1)"}
      w={"100%"}
      style={{ borderRadius: 20 }}
    >
      <IconCaretDownFilled
        size={20}
        color="black"
        onClick={onToggle}
        style={{
          cursor: "pointer",
          transform: isExpanded ? "rotate(0deg)" : "rotate(180deg)",
          transition: "transform 0.3s ease",
          marginLeft: 12,
        }}
      />

      <Flex direction="column">
        <Text size="lg" fw={500} c="#B046AC">
          {t("bankCredit.header.title")}
        </Text>

        <Flex direction="row" gap="md" align="center">
          {headerItems.map(({ value, label, formatValue }, index) => (
            <Flex key={index} direction="row" gap={4} align="center">
              <Text size="sm" c="black">
                {`${label}:`}
              </Text>
              {value ? (
                formatValue()
              ) : (
                <Text size="md" fw={500}>
                  _ _ _
                </Text>
              )}
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};
